import { render } from "./CubeCalculator.vue?vue&type=template&id=21c64810"
import script from "./CubeCalculator.vue?vue&type=script&lang=js"
export * from "./CubeCalculator.vue?vue&type=script&lang=js"

import "./CubeCalculator.vue?vue&type=style&index=0&id=21c64810&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__